export default {
    ieltsExamLabel: "IELTS",
    ieltsExamShortInfo: "International English Language Testing System — Academic et General.",
    ieltsExamLabelFull: "International English Language Testing System",
    ieltsExamDescription: "L'IELTS est l'un des tests de compétence en anglais les plus reconnus au monde, accepté pour les études, le travail et l'immigration. Il évalue la compréhension orale, la compréhension écrite, l'expression écrite et l'expression orale. LinguaScore propose une préparation pour les modules Academic et General Training, avec des tests blancs complets et des exercices ciblés.",
    ieltsExamStructure: "Compréhension orale (30 min), Compréhension écrite (60 min), Expression écrite (60 min), Expression orale (11–14 min). Les résultats sont exprimés en bandes de score de 0 à 9.",
    ieltsBeginnerTierDescription: "Compétences en anglais très limitées ou inexistantes",
    ieltsElementaryTierDescription: "Compréhension de base avec des erreurs fréquentes",
    ieltsIntermediateTierDescription: "Maîtrise partielle de la langue",
    ieltsUpperIntermediateTierDescription: "Communication efficace dans la plupart des situations",
    ieltsAdvancedTierDescription: "Bonne maîtrise opérationnelle",
    ieltsProficientTierDescription: "Anglais très fluide et précis",
    ieltsSectionTerminology:"Partie {{sectionNumber}}",
    ieltsSpeakingPartOneLabel:"Introduction et Entretien",
    ieltsSpeakingPartTwoLabel:"Prise de Parole Individuelle",
    ieltsSpeakingPartThreeLabel:"Discussion Bilatérale",
    ieltsSpeakingCandidateLabel:"Vous",
    ieltsSpeakingExaminerLabel:"Examinateur",
    ieltsSpeakingExaminerActionLabel:"En train de parler...",
    ieltsSpeakingManualListeningActionLabel:"Touchez pour écouter",
    ieltsSpeakingRecordingLabel:"Enregistrement: {{seconds}}",

    tcfExamLabel: "TCF",
    tcfCAExamLabel: "TCF Canada",
    tcfExamShortInfo: "Test de connaissance du français — pour les études et l'immigration en France.",
    tcfCAExamShortInfo: "TCF pour le Canada — compétence en français pour l'immigration canadienne.",
    tcfExamLabelFull: "Test de Connaissance du Français",
    tcfFRBeginnerTierDescription: "Connaissances très basiques du français",
    tcfFRElementaryTierDescription: "Communication simple au quotidien",
    tcfFRIntermediateTierDescription: "Utilisateur autonome",
    tcfFRUpperIntermediateTierDescription: "Français correct et aisé",
    tcfFRAdvancedTierDescription: "Usage de la langue fluide et structuré",
    tcfFRProficientTierDescription: "Maîtrise du français",

    tcfCABeginnerTierDescription: "Capacité de communication minimale",
    tcfCAElementaryTierDescription: "Maîtrise fonctionnelle de base",
    tcfCAIntermediateTierDescription: "Atteint l'exigence minimale d'immigration",
    tcfCAUpperIntermediateTierDescription: "Solide maîtrise professionnelle",
    tcfCAAdvancedTierDescription: "Fort impact sur votre score SCG",
    tcfCAProficientTierDescription: "Niveau proche de celui d'un locuteur natif",

    toeflExamLabel: "TOEFL",
    toeflExamShortInfo: "Test of English as a Foreign Language — reconnu dans le monde entier.",
    toeflExamLabelFull: "Test Of English as a Foreign Language",
    toeflExamDescription: "Le TOEFL est largement utilisé pour les admissions universitaires et les certifications professionnelles en milieu anglophone. Le test évalue la compréhension écrite, la compréhension orale, l'expression orale et l'expression écrite dans un contexte académique. Préparez-vous avec les tests d'entraînement et ressources de LinguaScore, alignés sur le format TOEFL iBT.",
    toeflExamStructure: "Compréhension écrite (54–72 min), Compréhension orale (41–57 min), Expression orale (17 min), Expression écrite (50 min). Score total de 0 à 120.",
    toeflBeginnerTierDescription: "Compétence en anglais très limitée",
    toeflElementaryTierDescription: "Compétences de communication de base",
    toeflIntermediateTierDescription: "Anglais académique fonctionnel",
    toeflUpperIntermediateTierDescription: "Bonne performance académique",
    toeflAdvancedTierDescription: "Solide compétence académique",
    toeflProficientTierDescription:"Anglais académique quasi natif",

    beginnerTierLabel:"Débutant",
    elementaryTierLabel:"Élémentaire",
    intermediateTierLabel:"Intermédiaire",
    upperIntermediateTierLabel:"Intermédiaire avancé",
    advancedTierLabel:"Avancé",
    proficientTierLabel:"Maîtrise",

    listeningSectionLabel:"Compréhension Orale",
    readingSectionLabel:"Comprehension Écrite",
    speakingSectionLabel:"Expression Orale",
    writingSectionLabel:"Expression Écrite",

    languageTestSetupTitle: "Configurer votre Test",
    languageTestSetupDescription: "Parlez-nous de l'examen de langue que vous préparez et de vos objectifs.",
    languageTestSetupActionLabel: "Continuer",
    examSessionLabel:"Session",
    examSoonAvailableLabel:"Bientôt"
}
